// extracted by mini-css-extract-plugin
module.exports = {"button":"layout_button__h2xIE","lightBackground":"layout_lightBackground__AhheQ","darkBackground":"layout_darkBackground__EjoT_","buttonMobile":"layout_buttonMobile__GUgNT"};